import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeroActionsStyled, HeroCtaButton } from './styles';
import { smoothScrollToElement, smoothScrollToPosition } from '../../utils/smoothScroll';

interface HeroActionsProps {
  onLoginClick?: () => void;
}

const HeroActions: React.FC<HeroActionsProps> = ({ onLoginClick }) => {
  const { t } = useTranslation();

  const handleCtaClick = () => {
    if (typeof document === 'undefined' || typeof window === 'undefined') {
      return;
    }

    const pricingSection = document.getElementById('pricing');
    const enterpriseCard = pricingSection?.querySelector('[data-plan="enterprise"]') as HTMLElement | null;

    if (enterpriseCard instanceof HTMLElement) {
      const rect = enterpriseCard.getBoundingClientRect();
      const targetPosition = window.pageYOffset + rect.top - (window.innerHeight / 2) + (rect.height / 2);
      smoothScrollToPosition(targetPosition, { duration: 1000, offset: 0 });
    } else if (pricingSection instanceof HTMLElement) {
      smoothScrollToElement(pricingSection, { duration: 1000 });
    }
  };

  return (
    <HeroActionsStyled>
      <HeroCtaButton onClick={handleCtaClick}>
        {t('hero.cta')}
      </HeroCtaButton>
    </HeroActionsStyled>
  );
};

export default HeroActions;
